import React, { useState } from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";

const ManageBookingModal = ({ show, handleClose, bookings }) => {
  const statusOptions = [
    { label: "In Progress", value: "In Progress" },
    { label: "Pending", value: "Pending" },
    { label: "Booked", value: "Booked" },
    { label: "Cancelled", value: "Cancelled" },
    { label: "Confirmed", value: "Confirmed" },
    { label: "Completed", value: "Completed" },
  ];
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Manage Bookings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bookings.length > 0 ? (
          <div className="table-responsive">
            <table className="table ">
              <thead>
                <tr>
                  <th>Booking Date</th>
                  <th>Customer Name</th>
                  <th>Service Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((booking, index) => (
                  <tr key={booking.id}>
                    <td>
                      {new Date(booking.bookingDate).toLocaleDateString()}
                    </td>
                    <td>{booking.customerName}</td>
                    <td>{booking.packageName}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle
                          as="div"
                          className="btn-select-drop default-select btn i-false"
                        >
                          {booking.status}
                          <i className="fas fa-angle-down ms-2"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {statusOptions.map((status) => {
                            if (status.value === booking.status) return null;
                            return (
                              <Dropdown.Item key={status.value}>
                                {status.label}
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No bookings available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ManageBookingModal;
